import React, { useEffect, useState } from 'react';

import { Wrap, Header } from '@components';
import { Outlet } from 'react-router-dom';
const ClausePage = () => {
  return (
    <Wrap>
      <Outlet />
    </Wrap>
  );
};

export default ClausePage;
